// LLM generated - Model Claude 4 Sonnet
import { Match } from '~/domains/common/components/Match/Match';

import { WithdrawalPaymentMethods } from './WithdrawalPaymentMethods';
import { RefundPaymentMethods } from './RefundPaymentMethods';
import { PaymentMethodsSkeleton } from './PaymentMethodsSkeleton';

type PaymentMethodsModeSwitchProps = {
  mode: 'withdrawal' | 'refund';
  isAeropayEnabled: boolean;
  isLoadingPaymentMethods: boolean;
  onWithdrawalMethodSelect?: () => void;

  // Refund data passed from parent hook
  refundableBreakdown?: any;
  isFetchingRefundableBreakdown?: boolean;
  hasConsistencyError?: boolean; // NEW: Error state for balance consistency issues
};

export function PaymentMethodsModeSwitch({
  mode,
  isAeropayEnabled,
  isLoadingPaymentMethods,
  onWithdrawalMethodSelect,
  refundableBreakdown,
  isFetchingRefundableBreakdown,
  hasConsistencyError,
}: PaymentMethodsModeSwitchProps) {
  // Show loading skeleton during data loading
  if (isLoadingPaymentMethods) {
    return <PaymentMethodsSkeleton isAeropayEnabled={isAeropayEnabled} />;
  }

  // Show appropriate payment methods based on mode
  return (
    <Match value={mode}>
      <Match.On value={['withdrawal']}>
        <WithdrawalPaymentMethods
          isAeropayEnabled={isAeropayEnabled}
          isLoadingPaymentMethods={false}
          onWithdrawalMethodSelect={onWithdrawalMethodSelect}
        />
      </Match.On>
      <Match.On value={['refund']}>
        <RefundPaymentMethods
          refundableBreakdown={refundableBreakdown}
          isFetchingRefundableBreakdown={isFetchingRefundableBreakdown}
          hasConsistencyError={hasConsistencyError}
        />
      </Match.On>
    </Match>
  );
}
